import moment from "moment";
import DeviceIconsCollection from "../../components/Icons/DeviceIconsCollection";
import { convertPath, electronConfig, isElectron, permissions, socket } from "../../libs/roomnew";
import { logError, notifyUser } from '../../utils/errorHandler';
let ACCESS_TOKEN = '';
export function openActiveSessionDetectedModal(sessions,token,success,cancel){
    if(!sessions){
        cancel();
        return
    }
    $("#access-session-container").html('')
    sessions.forEach(session => {
        renderActiveSession(session);
    });
    $("#workspace-access-cancel").off('click');
    $("#workspace-access-switch-device").off('click');

    $("#workspace-access-cancel").on('click',()=>{
        $("#activeSessionDetectedModal").modal('hide');
        cancel();
    })

    $("#workspace-access-switch-device").on('click',()=>{
        switchDevice(token).then(()=>{
            $("#activeSessionDetectedModal").modal('hide');
            success();
        }).catch(err=>{
            logError(err, 'switchDevice'); notifyUser('Failed to switch device.');
        });
    })

    $("#activeSessionDetectedModal").modal();
}

function renderActiveSession(session){
    const platform = session.platform_name;
    const appName = session.app_name;
    const status = session.status;
    const sessionTime = moment(session.start_date).format("MMM Do h:mma");
    const deviceIcon=getDeviceIcon(session.platform);
    const deviceInfo=$('<div/>',{
        class:'d-flex flex-column flex-1 h-48px',
        html:`
        <p class="font-weight-bold mb-0 text-kino-red">${platform}</p>
        <span>${appName}</span>`
    })
    const sessionStatus=$("<div/>",{
        class:'align-items-end d-flex flex-column h-48px justify-content-between',
        html:`<span class="badge bg-green px-3 py-1">${status}</span>
        <span class="text-sm">${sessionTime}</span>`
    })
    const sessionContainer=$("<div/>",{
        class:'d-flex w-100 active-session mb-2',
        html:[deviceIcon,deviceInfo,sessionStatus]
    })

    $("#access-session-container").append(sessionContainer)
}

function getDeviceIcon(device){
    if(DeviceIconsCollection.hasOwnProperty(device)){
        return DeviceIconsCollection[device]
    }
}

function accessCheckRequest(kino_id){
    return new Promise(async (resolve,reject)=>{
        axios.post(convertPath(`/workspace/${kino_id}/access-check`),{},await electronConfig()).then(res=>{
            resolve(res.data);
        }).catch(err=>{
            console.error(err);
            reject(err?.response?.data);
        })
    })
}

export function hasDeviceAccessToContinue(){
    return new Promise((resolve,reject)=>{
        if(!permissions.isWorkspace){
            return resolve();
        }
        const kino_id = permissions.kino_id;
        accessCheckRequest(kino_id)
        .then(data=>{
            if(data?.allowed === true){
                setAccessToken(data.token);
                resolve(data);
            }else{
                if(!data.sessions){
                    $.showNotification({
                        body: data.message,
                        type: "white",
                        duration: 6000
                    });
                    reject(data);
                    return
                }
                setAccessToken(data.token);
                openActiveSessionDetectedModal(data?.sessions,data?.token,resolve,reject);
            }
        })
        .catch(errors=>{
            reject(errors)
        })
    })
}

function setModalWaitingState(){

}

function switchDevice(token){
    setModalWaitingState();
    return new Promise((resolve,reject)=>{
        socket.sendSwitchSessionMessage(token).then(resolve).catch(message=>{
            console.error(message)
        })
    })
}


export function showSessionClosedModal(){
    $("#workspace-access-close-session").off('click');
    $("#workspace-access-close-session").on('click',()=>{
        if(isElectron){
            location.href=api.global.dirname+'src/html/pages/welcome.ejs';
        }else{
            window.location.replace('/profile/dashboard');
        }
    })
    $("#sessionClosedModal").modal()
}


export function getAccessToken(){
    return ACCESS_TOKEN;
}

export function setAccessToken(token){
    ACCESS_TOKEN = token;
}
